<template>
    <div>
        <canvas ref="canvas"></canvas>
    </div>
</template>

<script>
import bwipjs from 'bwip-js/dist/bwip-js-min.js'

export default {
    name: 'CodeBarre',
    props: {
        codeClient: { type: String, required: true },
        scale: { type: Number, default: 3 },
        includeText: { type: Boolean, default: true }
    },
    async mounted() {
        const canvas = this.$refs.canvas;

        try {
            await bwipjs.toCanvas(canvas, {
                bcid: 'code128',
                text: this.codeClient,
                scale: this.scale,
                includetext: this.includeText,
                textxalign: 'center',
            });
        } catch (err) {
            console.error('Erreur génération barcode:', err);
        }
    }
}

</script>